import { ChevronLeft, ChevronRight } from 'lucide-react';
import './DashboardPagination.scss';

export default function DashboardPagination({ page, pageSize, totalCount, onPageChange }) {
    const className = 'dashboardPagination';
    const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
    const currentPage = page + 1;

    if (totalCount === 0) return null;

    const rangeStart = page * pageSize + 1;
    const rangeEnd = Math.min(totalCount, rangeStart + pageSize - 1);

    return (
        <div className={className}>
            <span className={className + '__range'}>
                {rangeStart}–{rangeEnd} of {totalCount}
            </span>
            <div className={className + '__controls'}>
                <button
                    type="button"
                    className={className + '__button'}
                    disabled={page <= 0}
                    onClick={() => onPageChange(page - 1)}
                    aria-label="Previous page"
                >
                    <ChevronLeft />
                </button>
                <span className={className + '__page'}>
                    Page {currentPage} of {totalPages}
                </span>
                <button
                    type="button"
                    className={className + '__button'}
                    disabled={currentPage >= totalPages}
                    onClick={() => onPageChange(page + 1)}
                    aria-label="Next page"
                >
                    <ChevronRight />
                </button>
            </div>
        </div>
    );
}
